'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var _classCallCheck = _interopDefault(require('babel-runtime/helpers/classCallCheck'));
var _createClass = _interopDefault(require('babel-runtime/helpers/createClass'));
var $ = _interopDefault(require('jquery'));
var utils_js = require('../helpers/utils.js');
var A11y = _interopDefault(require('./a11y-helpers.js'));

var PrettyScrollTo = function () {
  function PrettyScrollTo(options, callback) {
    _classCallCheck(this, PrettyScrollTo);

    var config = {
      $selector: $('.link-scroll-to'),
      scrollClass: 'js-is-scrolling',
      scrollTime: 500
    };

    this.options = _Object$assign({}, config, options);

    // Support passing a DOM node as 'selector'
    if (this.options.selector) {
      this.options.$selector = $(this.options.selector);
    }

    this.callback = callback;
    this.init();
  }

  _createClass(PrettyScrollTo, [{
    key: 'init',
    value: function init() {
      var _this = this;

      $(this.options.$selector).on('click', function (evt) {
        _this.handleClick(evt);
      });
    }
  }, {
    key: 'handleClick',
    value: function handleClick(evt) {
      var _this2 = this;

      var link = evt.currentTarget;
      var $target = void 0;
      var hash = void 0;
      var offsetTop = void 0;

      // IE's 'a' element pathname doesn't return the leading slash because IE
      var path = link.pathname.replace(/(^\/?)/, '/');

      if (link.host === window.location.host && path === window.location.pathname && link.hash) {
        hash = link.hash;
        $target = utils_js.getJQueryObjectFromHash(hash);

        if ($target.length) {
          evt.preventDefault();

          offsetTop = this.options.offset ? $target.offset().top + this.options.offset : $target.offset().top;

          if (typeof window.history !== 'undefined' && typeof window.history.replaceState !== 'undefined') {
            window.history.replaceState({}, document.title, hash);
          }

          // Hack to fix PrettyScrollTop issues in FF and IE
          // eslint-disable-next-line promise/catch-or-return
          $('body, html').stop().addClass(this.options.scrollClass).animate({ scrollTop: offsetTop }, this.options.scrollTime).promise().then(function () {
            $('body, html').removeClass(_this2.options.scrollClass);
            A11y.prototype.pageLinkFocus($target);
            if (typeof _this2.callback === 'function') {
              _this2.callback(link, $target);
            }
          });
        }
      }
    }
  }]);

  return PrettyScrollTo;
}();

module.exports = PrettyScrollTo;
